// eslint-disable-next-line boundaries/dependencies
import { StorageWrapper } from '../../../../code/client/shared/scripts/StorageWrapper.ts';
export { StorageWrapper };
